import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
// import Faq from "./views/Faq.vue";
// import Contact from "./views/Contact.vue";
// import Directory from "./views/Directory.vue";
// import About from "./views/About.vue";
// import Profiles from "./views/Profiles.vue";
// import ProfileDetails from "./views/ProfileDetails.vue";
// import Profile from "./views/Profile.vue";
// import Launchpad from "./views/Launchpad.vue";
// import Login from "./views/Login.vue";
// import ResetPassword from "./views/ResetPassword.vue";
// import ResetAdminPassword from "./views/ResetAdminPassword.vue";
// import EditProfile from "./views/EditProfile.vue";
// import Pricing from "./views/Pricing.vue";
// import Dashboard from "./views/Dashboard.vue";
// import Charities from "./views/Charities.vue";
// import Notices from "./views/Notices.vue";
// import NoticesAdd from "./views/NoticesAdd.vue";
// import FAQAdd from "./views/FAQAdd.vue";
// import ProfileList from "./views/ProfileList.vue";
// import ApproveProfile from "./views/ApproveProfile.vue";
// import Todo from "./views/Todo.vue";
// import PaymentSuccessfull from "./views/PaymentSuccessfull.vue";
// import PaymentNotSuccessfull from "./views/PaymentNotSuccessfull.vue";
// import LoginAdmin from "./views/LoginAdmin.vue";
// import Search from "./views/Search.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  // base: process.env.BASEURL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/faq",
      name: "faq",
      component: () => import(/* webpackChunkName: "Terms" */ "./views/Faq.vue")
    },
    {
      path: "/contact",
      name: "contact",
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/Contact.vue")
    },
    {
      path: "/directory",
      name: "directory",
      // component: Directory
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/Directory.vue")
    },
    {
      path: "/about",
      name: "about",
      // component: About
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/About.vue")
    },
    {
      path: "/profiles",
      name: "profiles",
      // component: Profiles
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/Profiles.vue")
    },
    {
      path: "/register",
      name: "register",
      // component: ProfileDetails
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/ProfileDetails.vue")
    },
    {
      path: "/profile/:profileId",
      name: "profile",
      // component: Profile
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/Profile.vue")
    },
    {
      path: "/launchpad",
      name: "launchpad",
      // component: Launchpad
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/Launchpad.vue")
    },
    {
      path: "/login",
      name: "login",
      // component: Login
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/Login.vue")
    },
    {
      path: "/resetPassword/:reset",
      name: "resetPassword",
      // component: ResetPassword
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/ResetPassword.vue")
    },
    {
      path: "/editProfile",
      name: "editProfile",
      // component: EditProfile
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/EditProfile.vue")
    },
    {
      path: "/pricing",
      name: "pricing",
      // component: Pricing
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/Pricing.vue")
    },
    {
      path: "/admin/dashboard",
      name: "dashboard",
      // component: Dashboard
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/Dashboard.vue")
    },
    {
      path: "/charities",
      name: "charities",
      // component: Charities
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/Charities.vue")
    },
    {
      path: "/notices",
      name: "notices",
      // component: Notices
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/Notices.vue")
    },
    {
      path: "/noticesadd",
      name: "noticesadd",
      // component: NoticesAdd
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/NoticesAdd.vue")
    },
    {
      path: "/faqadd",
      name: "faqadd",
      // component: FAQAdd
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/FAQAdd.vue")
    },
    {
      path: "/profilelist",
      name: "profilelist",
      // component: ProfileList
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/ProfileList.vue")
    },
    {
      path: "/profileAdmin",
      name: "profileAdmin",
      // component: ApproveProfile
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/ApproveProfile.vue")
    },
    {
      path: "/todo",
      name: "todo",
      // component: Todo
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/Todo.vue")
    },
    {
      path: "/paymentsuccess/:details",
      name: "paymentsuccess",
      // component: PaymentSuccessfull
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/PaymentSuccessfull.vue")
    },
    {
      path: "/paymentunsuccess/:details",
      name: "paymentunsuccess",
      // component: PaymentNotSuccessfull
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/PaymentNotSuccessfull.vue")
    },
    {
      path: "/loginAdmin",
      name: "loginAdmin",
      // component: LoginAdmin
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/LoginAdmin.vue")
    },
    {
      path: "/resetAdminPassword/:reset",
      name: "resetAdminPassword",
      // component: ResetAdminPassword
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/ResetAdminPassword.vue")
    },
    {
      path: "/search",
      name: "search",
      // component: Search
      component: () =>
        import(/* webpackChunkName: "Terms" */ "./views/Search.vue")
    }
  ]
});
